import { useState } from "react";
import { ChevronLeft, ChevronRight, Star, Quote } from "lucide-react";

const testimonials = [
  { name: "VIKING Life-Saving Equipment", role: "", text: "Our partition wall helps us keep dust out of sensitive areas and reduces the time spent cleaning between jobs.", rating: 5 },
  { name: "Metcash Trading Ltd", role: "", text: "With the help of NG Industries we were able to commence redevelopment works inside an active warehouse. The PVC wall kept dust and machinery fumes contained.", rating: 5 },
  { name: "North Metropolitan TAFE Balga", role: "", text: "We got a clear PVC dividing wall made up to keep noise and dust down for our masonry cutting and grinding areas. With the clear material we can keep an eye on students too.", rating: 5 },
  { name: "SJ Fresh", role: "", text: "The sliding curtain NG Industries made for us works a treat, we can keep the cool air from the aircon contained to one section and don't waste energy cooling the whole warehouse anymore.", rating: 5 },
];

export default function TestimonialsSection() {
  const [current, setCurrent] = useState(0);
  const next = () => setCurrent((p) => (p + 1) % testimonials.length);
  const prev = () => setCurrent((p) => (p - 1 + testimonials.length) % testimonials.length);

  return (
    <section data-testid="testimonials-section" className="py-24 bg-[#141414]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="industrial-line mx-auto mb-6" />
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4" style={{ fontFamily: "'Clash Display', sans-serif" }}>
            What Our Clients Say
          </h2>
        </div>
        <div className="relative max-w-3xl mx-auto">
          <div className="bg-[#0A0A0A] border border-[#2E2E2E] p-8 sm:p-12">
            <Quote size={32} className="text-[#FF5722]/30 mb-6" />
            <p className="text-base sm:text-lg text-[#A3A3A3] leading-relaxed mb-8">
              {testimonials[current].text}
            </p>
            <div className="flex items-center gap-2 mb-4">
              {[...Array(testimonials[current].rating)].map((_, i) => (
                <Star key={`star-${i}`} size={16} className="fill-[#FF5722] text-[#FF5722]" />
              ))}
            </div>
            <div>
              <p className="font-bold text-white" style={{ fontFamily: "'Clash Display', sans-serif" }}>{testimonials[current].name}</p>
              {testimonials[current].role && <p className="text-sm text-[#A3A3A3]">{testimonials[current].role}</p>}
            </div>
          </div>
          <div className="flex justify-center gap-4 mt-6">
            <button data-testid="testimonial-prev-btn" onClick={prev} className="w-10 h-10 border border-[#2E2E2E] flex items-center justify-center text-[#A3A3A3] hover:border-[#FF5722] hover:text-[#FF5722] transition-colors">
              <ChevronLeft size={18} />
            </button>
            <div className="flex items-center gap-2">
              {testimonials.map((t, i) => (
                <button key={`dot-${t.name}`} onClick={() => setCurrent(i)} className={`w-2 h-2 transition-colors ${i === current ? "bg-[#FF5722]" : "bg-[#2E2E2E]"}`} />
              ))}
            </div>
            <button data-testid="testimonial-next-btn" onClick={next} className="w-10 h-10 border border-[#2E2E2E] flex items-center justify-center text-[#A3A3A3] hover:border-[#FF5722] hover:text-[#FF5722] transition-colors">
              <ChevronRight size={18} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
